import React from "react";
import Footer from "../components/footer";
import IndeedLogo from "../images/IndeedLogo.png"
import SubpageTitle from "../components/subpageTitle";

function Apply() {
    return(
        <div>
            <div id="applyTitle">
                <SubpageTitle title="Apply Now" subtitle="We periodically add jobs to Indeed. We will get back to you as soon as we can once an application is received. Click below to view our openings." />
            </div>
            <div>
                <div>
                    <div className="w-full flex justify-center">
                        <a href="https://www.indeed.com/cmp/Bottle-Depot/jobs">
                            <img className="md:w-70 w-50" alt="Indeed Logo" id="IndeedLogo" src={IndeedLogo}></img>
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default Apply
